import webApiClientSingleton from '../webApiClientSingleton';

const logError = (message, error = {}) => {
  webApiClientSingleton.instance.logging.errorLog({
    message,
    context: { error: error.message },
  });
};

export default logError;
